import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

import { cn } from "@/lib/utils";

import { useRecoilState } from 'recoil';
import { tokenAtom } from '../../core/config/atoms';

import Moment from 'moment';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import moment from 'moment';
import { motion } from "framer-motion";
import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import { Calendar as CalendarIcon } from "lucide-react";

import animBtnLoading from '../../assets/anim/anim-btnLoading.json';

import TopBar from 'core/widgets/ui/TopBar';

import { API_URL } from 'services/models/AppConstent';
import APIResponse from 'services/models/APIResponse';

import videoIcon from '../../assets/image/clapperboard.png';

import ServiceUtility from 'services/serviceUtility';
import ServiceStore from 'services/serviceStore';

const allowedExtensions = ["png", "jpeg"];

export default function PanelStore() {

    const [token] = useRecoilState(tokenAtom);

    const [records, setRecords] = useState([]);
    const [files, setFiles] = useState([]);
    const [progres, setProgres] = useState([]);

    const [record, setRecord] = useState({});
    const [filter, setFilter] = useState({});

    const [thubFile, setThubFile] = useState(null);
    const [thubPreview, setThubPreview] = useState(null);

    const [date, setDate] = useState({
        from: Moment().startOf('month').toDate(),
        to: Moment().toDate(),
    });

    const [query, setQuery] = useState('');

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);
    const [progress, setProgress] = useState(0);
    const [imageIndex, setImageIndex] = useState(-1);

    const [isDate, setIsDate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [isZoomed, setIsZoomed] = useState(false);
    const [isUpload, setIsUpload] = useState(false);

    const storeService = new ServiceStore();
    const utilService = new ServiceUtility();

    const formVSchema = Yup.object().shape({
        title: Yup.string().required('This information is required'),
        subtitle: Yup.string().required('This information is required'),
        disc: Yup.string().required('This information is required'),
        url: Yup.string().required('This information is required')
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, setValues } = useFormik({
        initialValues: {
            title: '',
            subtitle: '',
            disc: '',
            url: ''
        },
        enableReinitialze: true,
        validationSchema: formVSchema,
        onSubmit: values => {
            if (isEdit) {
                let body = {
                    "uid": record._id,
                    "data": {
                        title: values.title,
                        subtitle: values.subtitle,
                        url: values.url,
                        summery: values.disc,
                    }
                }
                storeService.updateStore(body, token).then((res) => {
                    setSubmit(false);
                    if (res.status) {
                        toast.success("Store prodduct updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        setIsOpen(false);
                        setIsEdit(false);
                        setRecord({});
                        loadData();
                        handleReset();
                        setThubFile(null);
                        setThubPreview(null);
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            } else {
                if (thubFile !== null) {
                    setSubmit(true);
                    var formData = new FormData();
                    formData.append("path", 'store');
                    formData.append("doc", thubFile);
                    fnSubmit(formData, token);
                } else {
                    toast.error('Please select at least one image file.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            }
        },
    });

    const uploadFiles = () => {
        if (files.length !== 0) {
            setSubmit(true);
            const uploadPromises = files.map(uploadFile);
            Promise.all(uploadPromises).then((ress) => {
                let filesData = ress.map((re) => {
                    return re.data;
                });

                record.files.map((fils) => {
                    filesData.push(fils);
                });

                let body = {
                    "uid": record._id,
                    "data": {
                        "files": filesData
                    },
                };

                storeService.updateStore(body, token).then((res) => {
                    setSubmit(false);
                    setIsUpload(false);
                    setFiles([]);
                    setProgres([]);
                    setRecord({});
                    toast.success(`${ress.length} Files Uploaded`, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    loadData();
                });
            });
        } else {
            toast.error("Please select atleast one file for upload!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        }
    }

    const uploadFile = async (file, index) => {
        var formDataA = new FormData();
        formDataA.append("path", 'store');
        formDataA.append("doc", file);

        var url = `${API_URL}file/uploadFile`;
        var requestHeaders = {
            'Content-type': 'multipart/form-data',
            'Accept': '*/*',
            'Authorization': `bearer ${token}`,
        };

        const response = await axios.post(url, formDataA, {
            headers: requestHeaders,
            onUploadProgress: (progressEvent) => {
                const fileProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                setProgres((prevProgress) => {
                    const updatedProgress = [...prevProgress];
                    updatedProgress[index] = fileProgress;
                    return updatedProgress;
                });
            },
        });

        var main = response.data;
        return new APIResponse(
            main["data"],
            main["status"],
            main["statuscode"],
            main["msg"],
        );
    }

    const fnSubmit = (data, token) => {
        (async function () {
            setProgress(0);
            var url = `${API_URL}file/uploadFile`;
            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
                'Authorization': `bearer ${token}`,
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setProgress(progress);
                },
            });
            let resFile = responseFile.data.data;
            setProgress(0);

            let body = {
                title: values.title,
                subtitle: values.subtitle,
                url: values.url,
                summery: values.disc,
                media: [resFile],
            }
            storeService.setStore(body, token).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("New store prodduct added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    loadData();
                    handleReset();
                    setThubFile(null);
                    setThubPreview(null);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const handleFileChange = (e) => {
        var { value, name } = e.target;
        let isError = false;

        const inputFile = e.target.files[0];
        const fileExtension = inputFile?.type.split("/")[1];

        if (!allowedExtensions.includes(fileExtension)) {
            alert.show("Only .png file format is allowed, please try again!", { type: 'error' });
            isError = true;
        }

        if (isError) {
            return;
        }

        setThubFile(inputFile);

        const reader = new FileReader();
        reader.onload = () => {
            setThubPreview(reader.result);
        };
        reader.readAsDataURL(inputFile);
    };

    const handleFileChanges = (event) => {
        let TempFiles = [...files];
        let TempProgs = [...progres];
        const selectedFiles = event.target.files;

        for (let i = 0; i < selectedFiles.length; i++) {
            const file = selectedFiles[i];
            const fileExtension = selectedFiles[i]?.type.split("/")[1];

            if (!allowedExtensions.includes(fileExtension)) {
                toast.error("Only .png, .jpeg, .mp4 file format is allowed, please try again!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            } else {
                TempProgs.push(0);
                TempFiles.push(file);
            }
        }

        setProgres(TempProgs);
        setFiles(TempFiles);
    };

    const removeSelectedFile = (index) => {
        let TempFiles = [...files];
        TempFiles.splice(index, 1);
        setFiles(TempFiles);
    }

    const handleOnChange = (e) => {
        var { value, name } = e.target;
        switch (name) {
            case 'pageSize':
                setPageSize(value);
                break;
            case 'search':
                setQuery(value);
                break;
        }
    }

    const onDateChange = (event) => {
        setIsDate(true);
        setDate(event);
    }

    const handleZoomChange = (shouldZoom, selIndex) => {
        if (shouldZoom) {
            setImageIndex(selIndex);
            setIsZoomed(shouldZoom);
        } else {
            setImageIndex(-1);
            setIsZoomed(shouldZoom);
        }
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportData = (type) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 0,
                "size": 0,
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await storeService.getAllStore(body, token);
            var records = res.data.data;
            let items = [];

            records.forEach((item) => {
                items.push({
                    title: item.title,
                    subtitle: item.subtitle,
                    disc: item.disc,
                    url: item.url,
                    status: item.status,
                    createdAt: item.createdAt,
                });
            });

            if (type === "xlsx") {
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Stores");
                XLSX.writeFile(workbook, "Stores.xlsx");
            } else {
                let headers = ['title, subtitle, disc, url, status, createdAt'];
                let recordCsv = items.reduce((acc, record) => {
                    const { title, subtitle, disc, url, status, createdAt } = record
                    acc.push([title, subtitle, disc, url, status, createdAt].join(','))
                    return acc
                }, []);
                downloadFile({
                    data: [...headers, ...recordCsv].join('\n'),
                    fileName: 'Stores.csv',
                    fileType: 'text/csv',
                });
            }
        })();
    }

    const deleteRecord = (id, furl) => {
        let resBody = {
            path: furl
        }
        utilService.deleteFile(resBody, token).then((res) => {
            let body = {
                rid: id
            }
            storeService.delStore(body, token).then((res) => {
                if (res['status']) {
                    loadData();
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        });
    }

    const deleteFile = (fileurl, index) => {
        if (record.files.length <= 1) {
            toast.error('Connot delete this image', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
        } else {
            setSubmit(true);
            let bodyA = { "path": fileurl }
            utilService.deleteFile(bodyA, token).then((res) => {
                let filesData = [...record.files];
                filesData.splice(index, 1);
                let body = {
                    "uid": record._id,
                    "data": {
                        "files": filesData
                    },
                };
                storeService.updateStore(body, token).then((res) => {
                    setSubmit(false);
                    setRecord(res.data);
                    toast.success(`1 File Deleted`, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                });
            });
        }
    }

    const editRecord = (rec) => {
        setRecord(rec);
        setValues({ ...values, title: rec.title, subtitle: rec.subtitle, disc: rec.summery, url: rec.url });
        setIsEdit(true);
        setIsOpen(true);
    }

    const viewMedia = (rec) => {
        setRecord(rec);
        setIsView(true);
    }

    const uploadMedia = (rec) => {
        setRecord(rec);
        setIsUpload(true);
    }

    const pageChange = (pageValue) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": pageValue,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await storeService.getAllStore(body, token);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await storeService.getAllStore(body, token);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const nextPage = () => {
        if (pageCurrent < pageTotal) {
            pageChange(pageCurrent + 1);
        }
    }

    const prevPage = () => {
        if (pageCurrent > 1) {
            pageChange(pageCurrent - 1);
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [pageSize, query, date, filter]);

    return (
        <div className="w-full h-full py-3 px-3">
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 min-h-screen p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <form onSubmit={handleSubmit}>
                                    <div className='flex items-center justify-between text-2xl'>
                                        <h1 className='font-sans font-medium text-gray-900'>Add Store Product</h1>
                                        <span onClick={() => {
                                            setIsOpen(false);
                                            setIsEdit(false);
                                            setRecord({});
                                            loadData();
                                            handleReset();
                                            setThubFile(null);
                                            setThubPreview(null);
                                        }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                    </div>
                                    <hr className='my-4' />
                                    <div className="mb-8 space-y-4">

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Title<sup className="text-red-600">*</sup></label>
                                            <input type="text" id="title" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="Title" value={values.title} />
                                            {(errors.title && touched.title) && <p className='text-xs text-red-400 mt-1'>{errors.title}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Sub Title<sup className="text-red-600">*</sup></label>
                                            <input type="text" id="subtitle" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="Sub Title" value={values.subtitle} />
                                            {(errors.subtitle && touched.subtitle) && <p className='text-xs text-red-400 mt-1'>{errors.subtitle}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Product URL<sup className="text-red-600">*</sup></label>
                                            <input type="text" id="url" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. https://xxx/xxx" value={values.url} />
                                            {(errors.url && touched.url) && <p className='text-xs text-red-400 mt-1'>{errors.url}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Product Summery<sup className="text-red-600">*</sup></label>
                                            <textarea type="text" id="disc" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-40 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. product summery" value={values.disc} />
                                            {(errors.disc && touched.disc) && <p className='text-xs text-red-400 mt-1'>{errors.disc}</p>}
                                        </div>

                                        {
                                            !isEdit && <div className="mb-6">
                                                <label className="block mb-2 text-sm font-medium text-gray-600">Title Image File<sup className="text-red-600">*</sup></label>
                                                {
                                                    (thubFile === null) && <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                                        <div className="space-y-1 text-center">
                                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            <div className="flex text-sm text-gray-600">
                                                                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                                    <span>Upload a file</span>
                                                                    <input type="file" className="sr-only" onChange={handleFileChange} />
                                                                </label>
                                                                <p className="pl-1">or drag and drop</p>
                                                            </div>
                                                            <p className="text-xs text-gray-500">
                                                                .jpg or .png up to 2mb at 16:9 Ration
                                                            </p>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={thubPreview} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {thubFile.name}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }

                                        {
                                            submit && <div className='my-3'>
                                                <p className='text-xs text-gray-400'>Uploading....</p>
                                                <div className='w-full bg-gray-300 mt-1' style={{ height: '4px' }}>
                                                    <div style={{ width: `${progress}%`, transitionDuration: `4s` }} className="h-full transition-all bg-green-400"></div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                    <div className='w-full'>
                                        <button type="submit" className="w-full text-white bg-primeLight hover:bg-prime focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center" disabled={submit}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && isEdit ? "UPDATE" : "ADD"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            {
                isView && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 min-h-screen p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900'>Product - {record.title}</h1>
                                    <div className='flex items-center'>
                                        <span onClick={() => {
                                            setIsView(false);
                                            setRecord({});
                                            loadData();
                                        }} className='ml-3'><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                    </div>
                                </div>
                                <hr className='my-4' />
                                <div className="mb-4">
                                    {
                                        record.files.map((file, index) => {
                                            return <div className="pl-3 pr-4 py-3 text-sm bg-gray-100 rounded border mt-2">
                                                <div className='flex items-center justify-between'>
                                                    <div className="w-0 flex-1 flex items-center">
                                                        <ControlledZoom isZoomed={isZoomed} onZoomChange={(shouldZoom) => { handleZoomChange(shouldZoom, index); }}>
                                                            {file?.ext !== "mp4" && <img src={file.fileurl} alt="Icon Template" className={`w-10 h-10 ${isZoomed ? imageIndex === index ? '' : 'hidden' : ''}`} />}
                                                            {file?.ext === "mp4" && <img src={videoIcon} alt="Icon Template" className={`w-10 h-10 ${isZoomed ? imageIndex === index ? '' : 'hidden' : ''}`} />}
                                                        </ControlledZoom>
                                                        <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                            {file.name}&nbsp;
                                                            <i className="las la-link text-gray-400 text-lg"></i>
                                                        </span>
                                                    </div>
                                                    <div className="ml-4 flex-shrink-0">
                                                        <label className="relative cursor-pointer rounded-md font-medium text-blue-600 font-mono" onClick={() => {
                                                            setIsZoomed(true);
                                                        }}>
                                                            <span>View</span>
                                                        </label>&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <label className="relative cursor-pointer rounded-md font-medium text-red-600 font-mono" onClick={() => {
                                                            deleteFile(file.fileurl, index);
                                                        }}>
                                                            <span>Delete</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        })
                                    }
                                    {
                                        record.files.length === 0 && <div>
                                            <div>No media found in folder.</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            {
                isUpload && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 h-screen p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900'>Product - {record.title}</h1>
                                    <span onClick={() => {
                                        setIsUpload(false);
                                        setRecord({});
                                        setFiles([]);
                                        setProgres([]);
                                        loadData();
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <hr className='my-4' />
                                <div className="mb-4">
                                    <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                        <div className="space-y-1 text-center">
                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                            <div className="flex text-sm text-gray-600">
                                                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                    <span>Upload a file</span>
                                                    <input type="file" className="sr-only" multiple={true} onChange={handleFileChanges} />
                                                </label>
                                                <p className="pl-1">or drag and drop</p>
                                            </div>
                                            <p className="text-xs text-gray-500 text-center">
                                                PNG, JPG up to 12 MB<br />
                                            </p>
                                        </div>
                                    </div>
                                    {
                                        files.map((file, index) => {
                                            return <div className="pl-3 pr-4 py-3 text-sm bg-gray-100 rounded border mt-2">
                                                <div className='flex items-center justify-between'>
                                                    <div className="w-0 flex-1 flex items-center">
                                                        {file?.type.split("/")[1] !== "mp4" && <img src={URL.createObjectURL(file)} alt="Icon Template" className='w-10 h-10' />}
                                                        {file?.type.split("/")[1] === "mp4" && <img src={videoIcon} alt="Icon Template" className='w-10 h-10' />}
                                                        <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                            {file.name}&nbsp;
                                                            <i className="las la-link text-gray-400 text-lg"></i>
                                                        </span>
                                                    </div>
                                                    <div className="ml-4 flex-shrink-0">
                                                        <label className="relative cursor-pointer rounded-md font-medium text-red-600 font-mono" onClick={() => {
                                                            removeSelectedFile(index);
                                                        }}>
                                                            <span>Remove</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                {
                                                    progress[index] !== 0 && <div className='w-full bg-gray-300 mt-1' style={{ height: '4px' }}>
                                                        <div style={{ width: `${progress[index]}%`, transitionDuration: `4s` }} className="h-full transition-all bg-green-400"></div>
                                                    </div>
                                                }
                                            </div>
                                        })
                                    }
                                </div>
                                <div className='w-full'>
                                    <button type="button" className="w-full text-white bg-primeLight hover:bg-prime focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center" disabled={submit} onClick={() => {
                                        uploadFiles();
                                    }}>
                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                        {!submit && "UPLOAD"}
                                    </button>
                                </div>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            <ScrollArea className="w-full h-full py-3 px-3">
                <div className="grid grid-cols-12 grid-gap-2">
                    <div className="col-span-12 mt-2">
                        <div class="intro-y flex items-center justify-between h-10 border-b pb-4">
                            <h2 class="text-2xl font-medium font-serif truncate ml-2 text-prime">
                                Store Master
                            </h2>
                            <div className='flex z-50'>
                                <button className="py-1 px-3 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4" onClick={() => {
                                    setIsOpen(true);
                                }}><i className="las la-plus mr-2"></i> Add Record</button>
                                <TopBar />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 mt-4 px-2">
                    <div className="w-full shadow-md rounded-md border">
                        <table className="min-w-full divide-y divide-gray-200 px-4">
                            <thead className="bg-gray-50">
                                <tr className=''>
                                    <th scope="col" className="border-b border-gray-200" colSpan={4}>
                                        <div className='w-full grid grid-cols-12 gap-2'>
                                            <form className="items-center py-2 col-span-11 px-2 grid grid-cols-12 gap-2">
                                                <div className='col-span-3 flex'>
                                                    <Popover>
                                                        <PopoverTrigger asChild>
                                                            <Button id="date" variant={"outline"}
                                                                className={cn(
                                                                    "w-[300px] justify-start text-left font-normal",
                                                                    !date && "text-muted-foreground"
                                                                )}
                                                            >
                                                                <CalendarIcon className="mr-2 h-4 w-4" />
                                                                {date?.from ? (
                                                                    date.to ? (
                                                                        <>
                                                                            {Moment(date.from).format('MMM DD, yyyy')} -{" "}
                                                                            {Moment(date.to).format('MMM DD, yyyy')}
                                                                        </>
                                                                    ) : (
                                                                        Moment(date.from).format('MMM DD, yyyy')
                                                                    )
                                                                ) : (
                                                                    <span>Pick a date</span>
                                                                )}
                                                            </Button>
                                                        </PopoverTrigger>
                                                        <PopoverContent className="w-auto p-0" align="start">
                                                            <Calendar
                                                                initialFocus
                                                                mode="range"
                                                                defaultMonth={date?.from}
                                                                selected={date}
                                                                onSelect={onDateChange}
                                                                numberOfMonths={2}
                                                            />
                                                        </PopoverContent>
                                                    </Popover>
                                                </div>
                                                <div className='w-full flex col-span-9 items-center'>
                                                    <div className='w-[80px]'>
                                                        <p>Search :</p>
                                                    </div>
                                                    <input type="text" value={query} onChange={handleOnChange} name='search' placeholder="Search by title." className="w-full h-10 px-4 font-sans text-sm outline-none rounded border" />
                                                </div>
                                            </form>
                                            <div className='col-span-1 flex items-center'>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <button className="w-full py-1 px-2 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4"><i className="las la-file-download mr-2"></i> Export </button>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div
                                                            className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('xlsx');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .xlsx</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('csv');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .csv</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Title
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Summery
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Created At
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {
                                    records.length !== 0 && records.map((reco, index) => {
                                        return <tr className="hover:bg-gray-100" key={index}>
                                            <td className="px-2 py-4">
                                                <span className="inline-flex text-sm leading-5 font-semibold text-gray-900 w-[400px]">
                                                    <div className='flex'>
                                                        <img src={reco.files[0].fileurl} alt='Banner image' className='w-[180px] object-cover border rounded' />
                                                        <div className='ml-1'>
                                                            {reco.title}<br />
                                                            <div className='text-xs'>{reco.subtitle}</div>
                                                        </div>
                                                    </div>
                                                </span>
                                            </td>
                                            <td className="px-2 py-4">
                                                <span className="inline-flex text-sm leading-5 font-semibold text-gray-900 w-[440px]">
                                                    {reco.summery}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-blue-600">
                                                    {moment(reco.createdAt).format('DD MMM, yyyy')}
                                                </div>
                                            </td>
                                            <td>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <motion.i whileHover={{ scale: 1.1 }} class="las la-ellipsis-v text-lg"></motion.i>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-60px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            uploadMedia(reco);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-images text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Update Images</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            viewMedia(reco);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-image text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>View Images</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            editRecord(reco);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-pen text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Edit Record</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            if (reco.files.length >= 2) {
                                                                                viewMedia(reco);
                                                                            } else {
                                                                                deleteRecord(reco._id, reco.files[0].fileurl);
                                                                            }
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-trash text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Delete</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </td>
                                        </tr>
                                    })
                                }
                                {
                                    records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                        <td className="px-6 py-4 whitespace-nowrap" colSpan="4">
                                            <div className="text-sm text-red-600 text-center">
                                                No data found.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        <div className='flex py-2 px-4 items-center bg-blue-50'>
                            <p className='text-sm font-serif'>Show rows per page</p>
                            <select className='text-sm ml-2 bg-gray-100' name="pageSize" onChange={handleOnChange} value={pageSize}>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>
                            </select>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-serif mr-2'>Page {pageCurrent} of {pageTotal}</p>
                            <div onClick={() => { prevPage() }}><i className={`las la-angle-left w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ${pageCurrent <= 1 ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                            <div onClick={() => { nextPage() }}><i className={`las la-angle-right w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ml-2 text-black ${pageCurrent === pageTotal ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                        </div>
                    </div>
                </div>
            </ScrollArea >
        </div >
    )
}
